import { BigFormRow } from 'framework/ui/layout';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { TimelineNoteWysiwygInput } from 'domain/shared/core/input';

const StaffingNoteForm = () => (
  <>
    <BigFormRow>
      <TimelineNoteWysiwygInput artifactsSource="attachmentPaths" source="noteText" label="Note text" />
    </BigFormRow>
    <BigFormRow>
      <NoteAttachmentUploaderInput label="Attachments" source="attachmentPaths" isStaffingService={true} />
    </BigFormRow>
  </>
);

export default StaffingNoteForm;
